// extracted by mini-css-extract-plugin
export default {"logoContainer":"style_logoContainer__ZACYK"};